export const SET_STOCKS = 'SET_STOCKS';
export const SET_STOCKS_DATA_LOADING = 'SET_STOCKS_DATA_LOADING';
export const GET_SEARCH_PRODUCTS = 'GET_SEARCH_PRODUCTS';
export const SET_SEARCH_PRODUCTS_DATA_LOADING =
  'SET_SEARCH_PRODUCTS_DATA_LOADING';
export const GET_SEARCH_SUPPLIERS = 'GET_SEARCH_SUPPLIERS';
export const SET_SEARCH_SUPPLIERS_DATA_LOADING =
  'SET_SEARCH_SUPPLIERS_DATA_LOADING';
export const SET_SEARCH_STOCK_BY_ID = "SET_SEARCH_STOCK_BY_ID"; 
export const GET_SEARCH_CATEGORIES = 'GET_SEARCH_CATEGORIES';
export const SET_SEARCH_CATEGORIES_DATA_LOADING = 'SET_SEARCH_CATEGORIES_DATA_LOADING';
